import { FacebookPage } from './connections-state.model';

/* ------------------------ Main connections actions ------------------------ */
export class CreateBotConnection {
  static readonly type = '[Connections] Create bot connection';
  constructor(public provider: string, public providerData: any) {}
}

export class UpdateBotConnection {
  static readonly type = '[Connections] Update bot connection';
  constructor(public provider: string, public providerData: any) {}
}

export class RemoveBotConnection {
  static readonly type = '[Connections] Remove bot connection';
  constructor(public provider: string) {}
}

export class GetProvidersList {
  static readonly type = '[Connections] Get providers list';
}

/* ----------------------------- Facebook pages ----------------------------- */

export class GetFacebookConnection {
  static readonly type = '[Connections] Get facebook';
}

export class GetFacebookPages {
  static readonly type = '[Connections] Get facebook pages';
  constructor(public instagramPermission?: boolean) {}
}

export class ResetFacebookAuthStatus {
  static readonly type = '[Connections] Reset facebook auth status';
}

export class CreateFacebookConnection {
  static readonly type = '[Connections] Create facebook connection';
  constructor(public fdPage: FacebookPage, public botId?: string) {}
}

export class CreateFacebookConnectionWizard {
  static readonly type = '[Connections] Create facebook connection (wizard)';
  constructor(public fdPage: FacebookPage, public botId?: string) {}
}

export class UpdateFacebookConnectionWizard {
  static readonly type = '[Connections] Update facebook connection (wizard)';
  constructor(public fdPage: FacebookPage, public botId?: string) {}
}

export class DeleteFacebookConnectionWizard {
  static readonly type = '[Connections] Delete facebook connection (wizard)';
  constructor(public botId?: string) {}
}
